var _style, _path, _path2, _defs, _polygon, _path3, _defs2, _polygon2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkChocolate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F8EEE1;}\n\t.st1{fill:#C06950;}\n\t.st2{clip-path:url(#SVGID_2_);fill:#8B4D39;}\n\t.st3{fill:#DE2F45;}\n\t.st4{clip-path:url(#SVGID_4_);fill:#BE1C32;}\n\t.st5{fill:#CBD5DC;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.75,185.44c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.45,151.15,62.06,185.44,104.75,185.44"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.8,153.81c-4.62,4.62-12.11,4.62-16.73,0l0,0L55.6,97.34c-4.62-4.62-4.62-7.93,0-12.55L80.69,59.7 c4.62-4.62,7.93-4.62,12.55,0l56.46,56.46c4.62,4.62,4.62,12.11,0,16.73L128.8,153.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M80.7,59.7L55.6,84.79c-4.62,4.62-4.62,7.93,0,12.55l56.46,56.46c4.62,4.62,12.11,4.62,16.73,0l0,0 l20.91-20.91c4.62-4.62,4.62-12.11,0-16.73L93.24,59.7c-2.31-2.31-4.29-3.47-6.28-3.47C84.99,56.23,83.01,57.39,80.7,59.7"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#683929"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "145.53,145.44 85.49,85.41 102.83,68.06 98.65,63.88 81.31,81.22 68.15,68.06 63.97,72.25  77.13,85.41 54.74,107.8 58.92,111.98 81.31,89.59 141.35,149.62  "
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M128.8,157.99c-4.62,4.62-12.11,4.62-16.73,0l-29.28-29.28c-4.62-4.62-4.62-12.11,0-16.73l0,0l25.1-25.09 c4.62-4.62,12.11-4.62,16.73,0l0,0l29.28,29.28c4.62,4.62,4.62,12.11,0,16.73L128.8,157.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M107.88,86.88l-25.09,25.1c-4.62,4.62-4.62,12.11,0,16.73l0,0l29.28,29.28 c1.64,1.64,3.72,2.76,5.99,3.22h4.76c2.27-0.46,4.35-1.58,5.99-3.22l25.1-25.09c4.62-4.62,4.62-12.11,0-16.73l-29.28-29.28 c-2.22-2.22-5.23-3.47-8.37-3.46C113.11,83.42,110.1,84.66,107.88,86.88"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "127.79,84.32 101.18,152.34 83.43,143.47 121.88,81.36  "
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M118.34,80.61l6.27,6.27c-2.09,6.28-25.09,46.01-29.28,54.37c0,0-2.09,6.27-7.31,1.04 c-3.67-3.67-10.95-10.95-15.69-15.68c-2.01-2.01-2.03-6.34,0-8.36l37.64-37.64C114.16,76.43,118.34,80.61,118.34,80.61"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkChocolate);
export default __webpack_public_path__ + "static/media/Dark_chocolate.cdbb58b2f46307c42b64fcd80f3ca5df.svg";
export { ForwardRef as ReactComponent };